import { useEffect } from "react";
import { useDocumentMeta } from "../hooks/use-document-meta";
import { HeroV2 } from "../components/v2/HeroV2";
import { MarqueeStats } from "../components/v2/MarqueeStats";
import { TrustStripBPI } from "../components/v2/TrustStripBPI";
import { ProductsHorizontalSnap } from "../components/v2/ProductsHorizontalSnap";
import { CatalogRequestCTA } from "../components/v2/CatalogRequestCTA";
import { VideoBand } from "../components/VideoBand";
import { ManifestoSplit } from "../components/v2/ManifestoSplit";
import { GrilleGammes13 } from "../components/v2/GrilleGammes13";
import { KPIsCounters } from "../components/v2/KPIsCounters";
import { MultiSitesBlock } from "../components/v2/MultiSitesBlock";
import { TestimonialsCarouselLogos } from "../components/v2/TestimonialsCarouselLogos";
import { PackagingShowcase } from "../components/v2/PackagingShowcase";
import { FinalCTAParticles } from "../components/v2/FinalCTAParticles";

export default function Home() {
  // Home keeps the brand default title/description from index.html; only the canonical is set.
  useDocumentMeta({ title: null, description: null, canonicalPath: "/" });
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main data-testid="home-page">
      <HeroV2 />
      <MarqueeStats />
      <TrustStripBPI />
      <ProductsHorizontalSnap />
      <VideoBand
        videoSrc="catalog-frying.mp4"
        posterSrc="catalog-frying-poster.jpg"
        eyebrow="Cuisson · L'instant clé"
        title={<>La friture qui <span className="text-gradient-gold">décide tout.</span></>}
        tagline="On sélectionne les variétés qui tiennent en vitrine — jamais molles, jamais grasses."
        height="h-[55vh] lg:h-[60vh]"
        testId="home-video-interlude"
      />
      <ManifestoSplit />
      <GrilleGammes13 />
      <KPIsCounters />
      <MultiSitesBlock />
      <TestimonialsCarouselLogos />
      <PackagingShowcase />
      {/* Lead-gen block: pushes the catalogue request right before the final
          CTA. Two-step funnel — first capture intent (catalogue), then ask
          for full devis if they want more. */}
      <CatalogRequestCTA testId="home-catalog-cta" />
      <FinalCTAParticles />
    </main>
  );
}
